<template>
    <div class="tsa-signPassword" v-show="show" @touchmove.prevent>
        <div class="mask"></div>
        <div class="container">
            <h1>签署密码</h1>
            <div class="inputClass">
                <input type="password" v-model="value" placeholder="请输入签署密码" :class="errorMessageShow ? 'inputError' : ''" @input="input">
                <p class="error" v-show="errorMessageShow">{{ errorMessage }}</p>
            </div>
            <div class="checbox-container">
                <img @click="checkedFun" :src="checked ? require('./images/checkbox_true.png') : require('./images/checkbox_false.png')" alt="">
                <div>
                    <p @click="checkedFun">我已阅读并同意</p>
                    <span @click.stop="read">《数字证书服务协议》</span>
                </div>
            </div>
            <div class="btnGroup">
                <p class="cancel" @click="cancel"><span>取消</span></p>
                <p class="confirm" @click="confirm"><span>确定</span></p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'tsa-signPassword',
        data() {
            return {
                show: false,
                value: '',
                statusConfirm: 0,
                statusRead: 0,
                errorMessageShow: false,
                errorMessage: '密码长度为6位数字',
                checked: false,
                timeStamp: 0
            }
        },
        watch: {
            show (val) {
                if (!val) {
                    this.value = ''
                    this.errorMessageShow = false
                    this.checked = false
                }
            }
        },
        methods: {
            input (e) {
                let val = e.target.value
                if (!val || val.length < 6 || val.length > 8) {
                    this.errorMessageShow = true
                } else {
                    this.errorMessageShow = false
                }
            },
            cancel () {
                this.show = false
            },
            confirm () {
                console.log({
                    errorMessageShow: this.errorMessageShow,
                    value: this.value,
                    checked: this.checked
                })
                
                if (!this.value || this.value.length < 6 || this.value.length > 8) {
                    this.errorMessageShow = true
                    return
                }
                if (this.checked === false) {
                    this.$toast({
                        message: '请阅读并同意《数字证书服务协议》',
                        className: 'toastcustom'
                    })
                    return
                }
                this.statusConfirm++
            },
            read () {
                this.statusRead++
            },
            checkedFun () {
                this.checked = !this.checked
                if (this.checked === true) {
                    this.timeStamp = new Date().getTime()
                }
            }
        },
    }
</script>
<style scoped>
    .tsa-signPassword {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
    }
    .tsa-signPassword .mask {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.7);
    }
    .tsa-signPassword .container {
        position: absolute;
        width: 90%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-sizing: border-box;
        border-radius: 3px;
        font-size: 16px;
        padding-top: 10px;
    }
    .tsa-signPassword .container h1 {
        color: #666;
        margin: 0;
        text-align: center;
        line-height: 36px;
        font-size: 16px;
    }
    .tsa-signPassword .container .inputClass {
        padding: 15px 10px 0 10px;
        min-height: 78px;
        box-sizing: border-box;
    }
    .tsa-signPassword .container .inputClass input {
        width: 100%;
        box-sizing: border-box;
        /* height: 30px;
        line-height: 30px; */
        font-size: 16px;
        color: transparent;
        text-shadow: 0 0 0 #999;
        border: 1px solid #dedede;
        border-radius: 5px;
        padding: 4px 5px;
        width: 100%;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: none;
        color: #666;
    }
    .tsa-signPassword .container .inputClass .inputError {
        border: 1px solid #f00;
    }
    .tsa-signPassword .container .inputClass .error {
        color: red;
        font-size: 12px;
        min-height: 18px;
        margin-top: 2px;
    }
    .tsa-signPassword .container .checbox-container {
        display: flex;
        align-items: center;
        padding: 0 10px;
    }
    .tsa-signPassword .container .checbox-container img {
        margin-right: 6px;
        width: 14px;
        height: 14px;
    }
    .tsa-signPassword .container .checbox-container div {
        display: flex;
        align-items: center;
    }
    .tsa-signPassword .container .checbox-container p {
        font-size: 13px;
        color: #666;
    }
    .tsa-signPassword .container .checbox-container span {
        color: #26a2ff;
        font-size: 13px;
    }
    .tsa-signPassword .container .btnGroup {
        width: 100%;
        display: flex;
        border-top: 1px solid #ddd;
        margin-top: 15px;
    }
    .tsa-signPassword .container .btnGroup p {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        flex: 1;
    }
    .tsa-signPassword .container .btnGroup .cancel {
        border-right: 1px solid #ddd;
    }
    .tsa-signPassword .container .btnGroup .confirm {
        color: #26a2ff;
    }
</style>


// WEBPACK FOOTER //
// src/components/signPassword/index.vue